/**
 * Seletor de competência.
 *
 * O <input type="month"> nativo resolve o problema errado: obriga a saber de
 * antemão a competência e, no tema escuro, o widget do navegador fica ilegível.
 * Quem escritura anda mês a mês — então a navegação tem que ser um clique, e a
 * competência precisa estar escrita por extenso, não em 2026-07.
 */
import { useEffect, useRef, useState } from 'react';

const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
               'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const CURTO = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
               'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

const hoje = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};
const desloca = (comp, n) => {
  const [a, m] = comp.split('-').map(Number);
  const d = new Date(a, m - 1 + n, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export default function SeletorCompetencia({ valor, onChange, disponiveis }) {
  const [aberto, setAberto] = useState(false);
  const [ano, setAno] = useState(Number(valor.slice(0, 4)));
  const caixa = useRef(null);
  const atual = hoje();
  const [a, m] = valor.split('-').map(Number);

  // fecha ao clicar fora ou apertar Esc — o painel nao pode prender o usuario
  useEffect(() => {
    if (!aberto) return;
    const fora = (e) => { if (caixa.current && !caixa.current.contains(e.target)) setAberto(false); };
    const esc = (e) => { if (e.key === 'Escape') setAberto(false); };
    document.addEventListener('mousedown', fora);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', fora); document.removeEventListener('keydown', esc); };
  }, [aberto]);

  useEffect(() => { setAno(Number(valor.slice(0, 4))); }, [valor]);

  const temNota = (comp) => !disponiveis || disponiveis.includes(comp);
  const btn = {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: 30, height: 30, borderRadius: 8, cursor: 'pointer',
    border: '1px solid var(--border-strong)', background: 'var(--surface-2)',
    color: 'var(--text)', fontSize: 15, lineHeight: 1, padding: 0,
  };

  return (
    <div ref={caixa} style={{ marginLeft: 'auto', position: 'relative', display: 'flex', gap: 6 }}>
      <button style={btn} onClick={() => onChange(desloca(valor, -1))} title="Mês anterior">‹</button>

      <button
        onClick={() => setAberto(v => !v)}
        title="Escolher competência"
        style={{ ...btn, width: 'auto', padding: '0 14px', gap: 8, fontSize: 13.5,
                 fontWeight: 600, letterSpacing: .2,
                 borderColor: aberto ? 'var(--accent, #C4956A)' : 'var(--border-strong)' }}>
        {MESES[m - 1]} {a}
        <span style={{ fontSize: 10, opacity: .6 }}>▾</span>
      </button>

      <button style={btn} onClick={() => onChange(desloca(valor, 1))} title="Próximo mês">›</button>

      {valor !== atual && (
        <button onClick={() => onChange(atual)} title="Voltar para o mês corrente"
          style={{ ...btn, width: 'auto', padding: '0 10px', fontSize: 12,
                   color: 'var(--text-muted)' }}>hoje</button>
      )}

      {aberto && (
        <div style={{
          position: 'absolute', top: 38, right: 0, zIndex: 40, width: 268, padding: 12,
          borderRadius: 12, border: '1px solid var(--border-strong)',
          background: 'var(--surface, #141418)',
          boxShadow: '0 12px 32px rgba(0,0,0,.35)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        marginBottom: 10 }}>
            <button style={btn} onClick={() => setAno(y => y - 1)}>‹</button>
            <strong style={{ fontSize: 14, letterSpacing: .3 }}>{ano}</strong>
            <button style={btn} onClick={() => setAno(y => y + 1)}>›</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 6 }}>
            {CURTO.map((rot, i) => {
              const comp = `${ano}-${String(i + 1).padStart(2, '0')}`;
              const sel = comp === valor;
              const eAtual = comp === atual;
              const tem = temNota(comp);
              return (
                <button key={comp}
                  onClick={() => { onChange(comp); setAberto(false); }}
                  title={tem ? '' : 'Sem notas nesta competência'}
                  style={{
                    padding: '7px 0', borderRadius: 8, fontSize: 12.5, cursor: 'pointer',
                    fontWeight: sel ? 700 : 500,
                    border: `1px solid ${sel ? 'var(--accent, #C4956A)'
                              : eAtual ? 'var(--border-strong)' : 'transparent'}`,
                    background: sel ? 'var(--accent, #C4956A)' : 'transparent',
                    color: sel ? '#08080A' : tem ? 'var(--text)' : 'var(--text-muted)',
                    opacity: tem ? 1 : .45,
                  }}>
                  {rot}
                </button>
              );
            })}
          </div>
          <div style={{ display: 'flex', gap: 6, marginTop: 10, paddingTop: 10,
                        borderTop: '1px solid var(--border)' }}>
            <button onClick={() => { onChange(atual); setAberto(false); }}
              style={{ ...btn, flex: 1, width: 'auto', fontSize: 12 }}>Mês atual</button>
            <button onClick={() => { onChange(desloca(atual, -1)); setAberto(false); }}
              style={{ ...btn, flex: 1, width: 'auto', fontSize: 12 }}>Mês anterior</button>
          </div>
        </div>
      )}
    </div>
  );
}
